import { reactive } from 'vue'

export const uiState = reactive({
  isTornadoActive: false
})
